import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { FormTitle, Form, FullFormWrapper } from "../styles";
import { publicAPI } from "../../../utils/api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ContactForm = ({ ...props }) => {
  const [messageBody, setMessageBody] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const sendMessage = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!messageBody.name)
      return [toast.info("Name is empty"), setLoading(false)];
    if (!messageBody.email)
      return [toast.info("Email is empty"), setLoading(false)];
    if (!messageBody.phone)
      return [toast.info("Phone is empty"), setLoading(false)];
    if (!messageBody.message)
      return [toast.info("Massage is empty"), setLoading(false)];

    try {
      const emailDTO = messageBody;
      await publicAPI.post("/public/bacchus/contactus", emailDTO);
      let messageForm = document.getElementById("message-form");
      messageForm.reset();
      setLoading(false);
      toast.success("Message is sent. Thank you!");
    } catch (error) {
      toast.info("Currently we cannot receive message.");
      setLoading(false);
    }
  };

  const setMessageData = (value, attributes) => {
    setMessageBody({
      ...messageBody,
      [attributes]: value,
    });
  };

  return (
    <FullFormWrapper id="contact-us">
        <FormTitle>
          {t("getInTouch")}
        </FormTitle>
        <Form id="message-form">
          <div>
            <input
              type="text"
              id="name"
              required
              onChange={(e) => setMessageData(e.target.value, "name")}
              disabled={loading}
            />
            <label htmlFor="name">{t("name")}</label>
          </div>
          <div>
            <input
              type="text"
              id="email"
              required
              onChange={(e) => setMessageData(e.target.value, "email")}
              disabled={loading}
            />
            <label htmlFor="email">{t("email")}</label>
          </div>
          <div>
            <input
              type="text"
              id="phone"
              required
              onChange={(e) => setMessageData(e.target.value, "phone")}
              disabled={loading}
            />
            <label htmlFor="phone">{t("phone")}</label>
          </div>
          <div>
            <textarea
              cols="30"
              rows="4"
              id="message"
              style={{ resize: "none" }}
              required
              onChange={(e) => setMessageData(e.target.value, "message")}
              disabled={loading}
            ></textarea>
            <label htmlFor="message">{t("typeYourMessage")}</label>
          </div>
          <button onClick={(e) => sendMessage(e)}>
            {loading ? `${t("loading")}...` : t("send")}
          </button>
        </Form>
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </FullFormWrapper>
  );
};
export default ContactForm;
